function imageSlider() {
  const sliderMain = $('.js-main-slider');
  const sliderNav = $('.js-nav-slider');

  sliderMain.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    asNavFor: '.js-nav-slider',
    draggable: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          fade: false,
          arrows: true,
        },
      },
    ],
  });

  sliderNav.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-main-slider',
    dots: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          arrows: false,
        },
      },
    ],
  });
}

export default imageSlider;
